export default function getElapsedTimeInSeconds(startTime: number): string {
  const endTime = performance.now();
  const timeDifference = endTime - startTime;
  const elapsedTimeInSeconds = (timeDifference / 1000).toFixed(2);

  return elapsedTimeInSeconds;
}
